import SceneProperties from "../data/SceneProperties";

class SpikeModel {
    bottom:number;
    left:number;
    isTop:boolean;
    size:number;

    constructor(bottom:number, left:number, isTop = false) {
        this.bottom = bottom / 100 * window.innerHeight;
        this.left = left / 100 * document.body.clientWidth * SceneProperties.totalWidthFact;
        this.isTop = isTop;
        this.size = 0.025 * window.innerHeight;
    }

}

export default SpikeModel;